import { render, staticRenderFns } from "./batch-drawer.vue?vue&type=template&id=06f26230&scoped=true"
import script from "./batch-drawer.vue?vue&type=script&setup=true&lang=js"
export * from "./batch-drawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./batch-drawer.vue?vue&type=style&index=0&id=06f26230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f26230",
  null
  
)

export default component.exports